import 'webdatarocks/webdatarocks.highcharts';
import { Subscription } from 'rxjs';
import {AfterViewInit, Component, Input, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {TeamsService} from '../../../../services/teams/teams.service';
import {UsersService} from '../../../../services/users/users.service';
import * as Highcharts from 'highcharts';
import WebDataRocks from 'webdatarocks';

@Component({
    selector: 'app-allowances-highcharts-container',
    templateUrl: './allowances-highcharts-container.component.html',
    styleUrls: ['../analytics-common.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AllowancesHighchartsContainerComponent implements AfterViewInit, OnDestroy {
  @Input() teamType: 'all-team' | 'current-team' = 'all-team';
  public allowanceActivity = [];
  public chartTypes = [
    'area', 'areaspline', 'bar',
    'column', 'waterfall', 'funnel',
    'pie', 'arearange', 'areasplinerange',
    'columnrange', 'errorbar', 'bubble',
    'scatter', 'polygon', 'spline'
  ];
  private pivot: any;
  private chart?: Highcharts.Chart;
  private selection?: Subscription;
  private refreshTimer?: ReturnType<typeof setTimeout>;
  private loadVersion = 0;
  private destroyed = false;
  showSpinner = true;

  constructor(
      private teamsService: TeamsService,
      private usersService: UsersService
  ) { }

  ngAfterViewInit(): void {
    this.selection = this.teamsService.wellspaceChangedObservable.subscribe({
      next: (wellspace: any): void => {
        const version = ++this.loadVersion;
        clearTimeout(this.refreshTimer);
        this.showSpinner = true;
        if (wellspace) {
          this.refreshTimer = setTimeout(() => {
            this.teamsService.getMemberAnalytics(this.usersService.getCurrentUserId()).then((result: any) => {
              if (this.destroyed || version !== this.loadVersion) { return; }
              if (this.teamType === 'current-team') {
                this.allowanceActivity = result.filter((allowance: any) => allowance.teamName === wellspace.name);
              } else {
                this.allowanceActivity = result;
              }
              this.createChart();
            }).catch(err => {
              this.showSpinner = false;
              console.error('Error in getMemberAnalytics', err);
            });
          }, 600);
        }
      }, error: err => {
        this.showSpinner = false;
        console.error('Error in highcharts allowances container', err);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.loadVersion++;
    clearTimeout(this.refreshTimer);
    this.selection?.unsubscribe();
    this.chart?.destroy();
    this.pivot?.dispose();
  }

  createChart(): void {
    if (this.destroyed) { return; }
    this.chart?.destroy();
    this.chart = undefined;
    this.pivot?.dispose();
    const customizeToolbar = (toolbar: any): void  => {
      const tabs = toolbar.getTabs();
      toolbar.getTabs = () => {
        delete tabs[0];
        tabs.push({
          id: 'wdr-tab-default',
          title: 'Chart',
          handler: chartTypeHandler,
          icon: toolbar.icons.format,
          menu: this.chartTypes.map(chartType => ({title: chartType, id: 'wdr-tab-charttype-' + chartType, args: chartType, handler: chartTypeHandler}))
        });
        return tabs;
      };
    };
    const createChart = (chartType: string) => {
      this.pivot.highcharts.getData({
        type: chartType
      }, (data: any) => {
        if (!this.destroyed) { this.chart = Highcharts.chart('highchartsContainer', data); }
      }, (data: any) => {
        if (!this.destroyed) { this.chart = Highcharts.chart('highchartsContainer', data); }
      });
    };
    const chartTypeHandler = (args: any): void => {
      createChart(args);
    };
    this.pivot = new WebDataRocks({
      container: '#wdr-container',
      beforetoolbarcreated: customizeToolbar,
      report: {
        formats: [
          {
            name: '',
            thousandsSeparator: ',',
            decimalSeparator: '.',
            decimalPlaces: 2,
            currencySymbol: '$',
            currencySymbolAlign: 'left',
            nullValue: '',
            textAlign: 'right',
            isPercent: false
          }
        ],
        dataSource: {
          data: this.allowanceActivity
        },
        slice: {
          rows: [
            {
              uniqueName: 'transactionDate.Year'
            },
            {
              uniqueName: 'transactionDate.Month'
            },
            {
              uniqueName: 'transactionDate.Day'
            }
          ],
          columns: [
            {
              uniqueName: 'teamName'
            },
            {
              uniqueName: 'memberName'
            },
            {
              uniqueName: 'Measures'
            }
          ],
          measures: [
            {
              uniqueName: 'transactionAmount',
              aggregation: 'sum'
            }
          ]
        },
      }, // 'https://cdn.webdatarocks.com/reports/report.json',
      toolbar: true,
      reportcomplete: () => {
        this.pivot.off('reportcomplete');
        // createChart('line');
      }
    });
    this.showSpinner = false;
  }

}
